(function chatWidgetModule() {
  const CONFIG = {
    iframeId: "chat-widget-iframe",
    src: "https://chatbot.dekbed-discounter.nl",
    collapsed: { width: "168.48px", height: "40px", borderRadius: "6px" },
    expanded: {
      widthDesktop: "448px",
      heightDesktop: "546.6px",
      borderRadius: "8px",
    },
    scrollOffsetMobile: "150px",
    scrollOffsetDesktop: "82px",
    baseOffset: "1rem",
    activationWidth: 768, // max width allowed to load the widget
  };

  let iframe,
    bottomOffset = CONFIG.baseOffset,
    widgetInitialized = false,
    hasUserInteracted = false;

  function disablePageScroll() {
    const el = document.scrollingElement || document.documentElement;
    el.style.overflow = "hidden";
  }

  function enablePageScroll() {
    const el = document.scrollingElement || document.documentElement;
    el.style.overflow = "";
  }

  function createIframe() {
    if (
      document.getElementById(CONFIG.iframeId) ||
      window.innerWidth <= CONFIG.activationWidth
    )
      return;

    iframe = document.createElement("iframe");
    iframe.id = CONFIG.iframeId;
    iframe.src = CONFIG.src;
    iframe.title = "Dekbed‑Discounter Chatbot";
    iframe.loading = "lazy";
    Object.assign(iframe.style, {
      position: "fixed",
      bottom: bottomOffset,
      right: "1rem",
      border: "none",
      boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
      zIndex: "9999",
      transition: "all 0.3s ease",
      overflow: "hidden",
      ...CONFIG.collapsed,
    });
    document.body.appendChild(iframe);

    widgetInitialized = true;

    window.addEventListener("scroll", adjustOnScroll, { passive: true });
    window.addEventListener("message", handleMessage);
  }

  function removeIframe() {
    if (iframe) {
      iframe.remove();
      iframe = null;
      widgetInitialized = false;
      enablePageScroll();
    }
  }

  function expand() {
    const vw = window.innerWidth;
    const vh = window.innerHeight;
    let styles;

    if (vw <= 480) {
      disablePageScroll();
      styles = {
        width: "100vw",
        height: `${vh}px`,
        bottom: "0",
        right: "0",
        borderRadius: "0",
      };
    } else if (vw <= CONFIG.activationWidth) {
      styles = {
        width: "90vw",
        height: "90vh",
        borderRadius: CONFIG.expanded.borderRadius,
      };
    } else {
      styles = {
        width: CONFIG.expanded.widthDesktop,
        height: CONFIG.expanded.heightDesktop,
        borderRadius: CONFIG.expanded.borderRadius,
      };
    }

    Object.assign(iframe.style, styles);
  }

  function collapse() {
    enablePageScroll();
    Object.assign(iframe.style, {
      width: CONFIG.collapsed.width,
      height: CONFIG.collapsed.height,
      borderRadius: CONFIG.collapsed.borderRadius,
      bottom: bottomOffset,
      right: "1rem",
    });
  }

  function adjustOnScroll() {
    const vw = window.innerWidth;

    // If widget shouldn't exist on mobile, remove it
    if (vw <= CONFIG.activationWidth) {
      removeIframe();
      return;
    }

    const btn = document.querySelector(".f8pr-button");
    const scrolledOff = btn && btn.getBoundingClientRect().bottom <= 0;

    bottomOffset = scrolledOff
      ? vw <= 760
        ? CONFIG.scrollOffsetMobile
        : CONFIG.scrollOffsetDesktop
      : CONFIG.baseOffset;

    if (iframe) iframe.style.bottom = bottomOffset;
  }

  function handleMessage(event) {
    if (event.source !== iframe?.contentWindow) return;
    if (event.data === "open-chat") expand();
    if (event.data === "close-chat") collapse();
  }

  function tryInitializeWidget() {
    if (
      hasUserInteracted ||
      window.innerWidth <= CONFIG.activationWidth ||
      widgetInitialized
    )
      return;
    hasUserInteracted = true;
    createIframe();
    window.removeEventListener("scroll", tryInitializeWidget);
    window.removeEventListener("mousemove", tryInitializeWidget);
    window.removeEventListener("touchstart", tryInitializeWidget);
  }

  // Attach interaction listeners to lazy-load
  window.addEventListener("scroll", tryInitializeWidget, { passive: true });
  window.addEventListener("mousemove", tryInitializeWidget, { passive: true });
  window.addEventListener("touchstart", tryInitializeWidget, { passive: true });

  // Resize handler to remove widget if screen gets too small
  window.addEventListener("resize", () => {
    if (window.innerWidth <= CONFIG.activationWidth) {
      removeIframe();
    } else if (hasUserInteracted && !widgetInitialized) {
      createIframe();
    }
  });
})();
